import { LogFirebase } from "../../../../../services/firestore";
import { CALL_DATA, GLOBAL_MEETING_DATA } from "../../../../../constants/PublicVariables";
import { setRemoteParticipanteAudioVideoStatus } from "../../../Room/roomFunction";

export const trackDisabledInRoomEvent = (track, participant) => {
    if (track) {
        LogFirebase("TwilioEvents", "trackDisabledInRoom", {
            track_details: track.kind,
            identity: participant.identity,
        });
        if (participant.identity != CALL_DATA.localIdentity) {
            if (GLOBAL_MEETING_DATA.ucid) {
                if (track.kind == "audio") {
                    setRemoteParticipanteAudioVideoStatus("audio", participant.identity, track.isTrackEnabled);
                }
                if (track.kind == "video") {
                    setRemoteParticipanteAudioVideoStatus("video", participant.identity, false);
                }
            }
        }
    }
};
